import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import styles from './breadcrumbs.module.css';

export interface Crumb {
    name: string;
    url?: string;
}

// Хлебные крошки + Schema.org BreadcrumbList (для пути в выдаче Google).
const Breadcrumbs: FC<{ items: Crumb[] }> = ({ items }) => {
    const jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: items.map((c, i) => ({
            '@type': 'ListItem',
            position: i + 1,
            name: c.name,
            ...(c.url ? { item: `https://svecha.am${c.url}` } : {}),
        })),
    };

    return (
        <nav className={styles.breadcrumbs} aria-label="breadcrumb">
            <Helmet>
                <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
            </Helmet>
            {items.map((c, i) => {
                const isLast = i === items.length - 1;
                return (
                    <span key={i} className={styles.crumb}>
                        {c.url && !isLast ? (
                            <Link to={c.url}>{c.name}</Link>
                        ) : (
                            <span className={styles.current}>{c.name}</span>
                        )}
                        {!isLast && <span className={styles.sep}>/</span>}
                    </span>
                );
            })}
        </nav>
    );
};

export default Breadcrumbs;
